export default function isOnePerBox(fulfillmentOrder) {
	return (
		fulfillmentOrder.fulfillmentOrderItems.length == 1 && fulfillmentOrder.fulfillmentOrderItems[0].product.onePerBox
	);
}
